import React from 'react'
import AdvancedSearch from '../advanced-search'

const AdvancedSearchDe = () => {
    return <AdvancedSearch languageCode="de" />
}

export default AdvancedSearchDe
